import UploadImgBtn from './UploadImgBtn';

export default UploadImgBtn;
